export default "__VITE_ASSET__e7aaf3b3__"